import { Suspense } from 'react';
import { Switch } from 'react-router';

import { SentryRoute, SuspenseFallback } from 'common/components';
import { useIgnoreResizeObserverError } from 'common/hooks';
import { lazyWithRetry } from 'common/utils';
import compose from 'lodash/fp/compose';
import { withProtectedRoute } from 'modules/authorization';
import { AppRoutes } from 'modules/router';
import JoinOrganization from 'pages/MasterAdmin/JoinOrganization';
import { withStoreRedirectUriToLocalStorage } from 'pages/PublicEventDetails/hocs';

import { CommunityCreationSuccessContainer, ReconnectingModalContainer } from './components';
import { withRedirectToEventFromLocalStorage, withUserAccount } from './hocs';

const MasterAdmin = lazyWithRetry(() => import('pages/MasterAdmin'), 'MasterAdmin');
const Dashboard = lazyWithRetry(() => import('preApp/components/Dashboard'), 'Dashboard');
const RegisterToCommunity = lazyWithRetry(() => import('pages/RegisterToCommunity'), 'RegisterToCommunity');

const App = () => {
  useIgnoreResizeObserverError();

  return (
    <>
      <Suspense fallback={<SuspenseFallback />}>
        <Switch>
          <SentryRoute path={AppRoutes.JoinOrganization} component={JoinOrganization} />
          <SentryRoute path={`${AppRoutes.Organization}/:orgSlug?`} component={MasterAdmin} />
          <SentryRoute path={AppRoutes.RegisterToCommunity} component={RegisterToCommunity} />
          {/* TODO: There should be separate route for registered user. It should start with e.g. /community/:id? */}
          <SentryRoute path="/" component={Dashboard} />
        </Switch>
      </Suspense>
      <ReconnectingModalContainer />
      <CommunityCreationSuccessContainer />
    </>
  );
};

export default compose(
  withStoreRedirectUriToLocalStorage,
  withProtectedRoute,
  withUserAccount,
  withRedirectToEventFromLocalStorage
)(App);
